module.exports = __webpack_public_path__ + "img/HeroTypesQuiz_SuperAgent.9b9ab241.png";